module.exports = __webpack_public_path__ + "static/media/powerpoint-icon.fac5349e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/powerpoint-icon.svg
// module id = 63
// module chunks = 0